import React from 'react';
import { Badge, Header, IconButtonProps, Popover } from '@economic/taco';
import { useLatestNotifications } from '../../../shared/hooks/useNotifications';
import NotificationsPanel from './Panel';
import { t } from '../../../shared/components/l10n/l10n';

export default function NotificationsIconButton({ className, ...props }: any) {
    const [notifications, lastSeenTimestamp, setLastSeenTimestamp, markNotificationsAsRead] = useLatestNotifications();

    const hasUnseenNotifications =
        lastSeenTimestamp &&
        notifications.some(
            notification => notification.read === false && notification.createdAt.getTime() > lastSeenTimestamp.getTime()
        );

    const buttonProps: Required<Pick<IconButtonProps, 'aria-label' | 'icon' | 'tooltip' | 'popover'>> = {
        'aria-label': 'Notifications',
        icon: 'bell-solid',
        tooltip: t`HEADER_TAB_NOTIFICATIONS`,
        popover: popoverProps => (
            <Popover {...popoverProps}>
                <Popover.Content aria-label="Notifications" className="!p-0 w-[375px]">
                    {({ close }) => (
                        <NotificationsPanel
                            notifications={notifications}
                            hide={close}
                            onOpened={setLastSeenTimestamp}
                            onMarkAsRead={markNotificationsAsRead}
                        />
                    )}
                </Popover.Content>
            </Popover>
        ),
    };

    return (
        <div className="relative" id="span_notification_navigation">
            <Header.Button {...buttonProps} {...props} as="span" />
            {hasUnseenNotifications ? (
                <Badge aria-label="Unread notifications" className="absolute top-[5px] right-[5px]" compact color="red">
                    Unread notifications
                </Badge>
            ) : null}
        </div>
    );
}
